import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { regions } from "../../../../../redux/route-management/regions/action";
import { useNavigate } from "react-router-dom";
import { selectRegionsListItems } from "../../../../../redux/route-management/regions/selector";
import PageLoader from "../../../../../components/PageLoader";

const ManagementRegions = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
    const itemsData = useSelector(selectRegionsListItems)
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'MobilityRegionName', headerName: 'MobilityRegionName', sortable: true, filter: true,isEdit: true },
          { field: 'ContactPerson', headerName: 'Contact Person' },
          { field: 'ContactNumber', headerName: 'Contact Number' },
          { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat:true },
          { field: 'ModifiedOnUtc', headerName: 'ModifiedOnUtc', isDateValueFormat:true}
      
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      const handleReloadData = () => {
    fetchRegions()
      }
      const fetchRegions=()=>{
        dispatch(regions.list({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/regions/list`,
          entity: 'regions',
          jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
       const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "MobilityRegionName",
        FieldText: "MobilityRegionName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]}
    }
      const handleDelete=(data: any)=>{
        dispatch(regions.delete({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/regions/delete`,
          entity: 'regions',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
          dispatch(regions.list({
              url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/regions/list`,
              entity: 'regions',
              jsonData: { "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
	useEffect(() => {
    createColumnDefs()
    fetchRegions()
  }, [pageData, pageSize])


  const additionButtons: any = [
        {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
        <title>Add</title>
        <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        callback: () => handleAdd(),
        },
        {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    }
  ];
	return (
<>
{itemsData?.isLoading ? <PageLoader />
        :
        <Table
          columnData={columnDefs}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          enableFilter={true}
          onSearch={handleSearch}
          setPageSize={setPageSize}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          additionButtons={additionButtons}
          onDelete={handleDelete}
          headingName="Regions" />
      }
</>
		
     
     
	);
};

export default ManagementRegions;


